export enum Scope {
  ADVERSE_MEDIA_PUBLICATION = 'AdverseMediaPublication',
  ADVERSE_MEDIA_SEARCH_CASE = 'AdverseMediaSearchCase',
  AFFILIATED_COMPANY = 'AffiliatedCompany',
  ALERTS = 'Alerts',
  BACK_OFFICE_STATISTICS = 'BackOfficeStatistics',
  BANK = 'Bank',
  BANK_APPLICATION = 'BankApplication',
  APPLICATION_BANK_ACCOUNTS = 'ApplicationBankAccounts',
  BANK_PORTAL = 'BankPortal',
  BANK_ACCOUNT_DETAILS = 'BankAccountDetails',
  CLIENT_PORTAL = 'ClientPortal',
  BIOTRACK_KEY = 'BiotrackKey',
  BSA = 'BSA',
  CLIENT_APPLICATION = 'ClientApplication',
  COMPANY = 'Company',
  COMPANY_DETAILS = 'CompanyDetails',
  COMPANY_DETAILS_CONTACTS_LIST = 'CompanyDetailsContactsList',
  CONFIGURATION = 'Configuration',
  CONNECTION = 'Connection',
  CONNECTION_DETAILS = 'ConnectionDetails',
  CONTACT = 'Contact',
  DOCUMENT = 'Document',
  DOCUMENT_FILE = 'DocumentFile',
  DOCUMENT_PERIOD = 'DocumentPeriod',
  INTERNAL_TRANSFER = 'InternalTransfer',
  INTERNAL_TRANSFER_EXPORT = 'InternalTransferExport',
  INVOICE = 'Invoice',
  LICENSE = 'License',
  METRC_KEY = 'MetrcKey',
  MFA = 'MFA',
  MR = 'MR',
  QR = 'QR',
  RELATIONSHIPS = 'Relationships',
  SALES_DATA = 'SalesData',
  TASK = 'Task',
  TEST = 'Test',
  USER = 'User',
  USER_LIST = 'UserList',
  CLIENT_USER = 'ClientUser',
  WEB_PAGE_DOCUMENT = 'WebPageDocument',
  WEB_PAGE_ONBOARDING = 'WebPageOnboarding',
  BANK_DOCUMENT_ONBOARDING_SIGNERS = 'BankDocumentOnboardingSigners'
}
